module.exports = __webpack_public_path__ + "img/powerbg.29dccff1.png";